import PermMediaIcon from '@material-ui/icons/PermMedia'
export const CreativesIcon = PermMediaIcon
